import { useRequestGetCreators } from '@/hooks/httpRequest/creators';
import { useFormCreator } from '@/hooks/forms';
import useUrlParams from './useUrlParams';

export const useCreators = () => {

	const { sortType, sortBy, limit, page, name, email, gender, createdAtFrom, createdAtTo } = useUrlParams();
	const result = useRequestGetCreators({
		createdAtFrom, 
		createdAtTo,
		sortType,
		sortBy,
		gender,
		limit,
		email,
		page,
		name
	});
	const { edit } = useFormCreator();

	return ({
		...result,
		edit
	});

};
